import { render } from "./AddPaymentModal.vue?vue&type=template&id=3db9990e&scoped=true&ts=true"
import script from "./AddPaymentModal.vue?vue&type=script&lang=ts"
export * from "./AddPaymentModal.vue?vue&type=script&lang=ts"

import "./AddPaymentModal.vue?vue&type=style&index=0&id=3db9990e&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/saas-fulfillment-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3db9990e"]])

export default __exports__